import { faCircleInfo } from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { faClipboard } from "@fortawesome/free-solid-svg-icons/faClipboard";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import {
  CampoTipoDocumento as TipoDocumento,
} from "../../../types/IncluirEditarParcela";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useState, useRef } from "react";

const estilosDropdown = require('../../../estilos/dropdownMenu.module.scss').default
const estiloAbaFormaDePagamento = require("./aba-forma-de-pagamento.module.scss").default;
const estilosBotoes = require('../../../estilos/botoes.module.scss').default
const estilosTabelas = require('../../../estilos/tabelas.module.scss').default
const estilosInputs = require('../../../estilos/inputs.module.scss').default
const estilosFormulario = require('../../../estilos/formulario.module.scss').default
const estiloTabela = require('../../../estilos/tabelas.module.scss').default

import clsx from 'clsx'
import { IOrcamento } from "app/types/IOrcamento";
import Legenda from "app/components/itens-orcamento/legenda/Legenda";
import { ParametroPorItem } from "app/types/Parametro";

export type FormaDePagamento = {
  Codigo?: number;
  Nome?: string;
  QuantidadeParcelasPrazo?: number;
};

export type ParcelaFormaDePagamento = {
  Codigo?: number
  DescricaoTipo?: "A Prazo" | "À Vista";
  Tipo?: 2
  Documento?: string;
  Valor?: number;
  Vencimento?: string;
  QuantidadeParcelasCartao?: number;
  ValorParcelasCartao?: number;
  RecebimentoNaEntrega?: boolean;
  DocumentoElegivelPIXaPrazo?: boolean // 414608
  Index: number;
};

export type TipoDeDocumento = {
  Codigo?: number;
  Descricao?: string;
};

export type AbaFormaDePagamentoProps = {
  parametrosPorFilial?: ParametroPorItem[]; // 414608
  processando?: boolean
  corSelecionada?: string;
  formasDePagamento: FormaDePagamento[];
  tiposDeDocumento: TipoDeDocumento[];
  onTipoDeDocumentoModificado: (codigo: number) => void;
  onFormaDePagamentoModificada: (codigo: number) => void
  onIgualarParcelasPrazo: () => void;
  onMostrarAjudaRecalcularParcelas: () => void;
  onMostrarAjudaRecalcularPrecos: () => void
  onIncluirParcela: () => void;
  onReceberNaEntrega: (valor: ParcelaFormaDePagamento) => void
  onEditarParcela: (codigo: number) => void;
  onExcluirParcelas: (codigosParcelas: number[]) => void;
  onRecalcularParcelasModificado: (recalcular: boolean) => void;
  onRecalcularPrecosModificado: (recalcular: boolean) => void
  parcelas: ParcelaFormaDePagamento[]
  orcamento: IOrcamento
  existePendenciaPrazoMedioEntrega: boolean
  exibirColunaReceberNaEntrega: boolean
  possuiCartaoParcelado: boolean
  onMarcarDesmarcarTodosReceberNaEntrega: (codigosParcelasSelecionadas: number[]) => void

};

const AbaFormaDePagamento = (props: AbaFormaDePagamentoProps) => {
  const somenteLeitura = props.orcamento?.SomenteLeitura || globalMU.isNotNullOrEmpty(props.orcamento?.CodigoDAV)

  const [exibirMenuAcoes, setExibirMenuAcoes] = useState(false)
  const [codigosParcelasSelecionadas, setCodigosParcelasSelecionadas] = useState<number[]>([])

  const isMounted = useRef(true)
  const selectFormaPagamentoRef = useRef<HTMLSelectElement>(null)
  const jaFocouFormaPagamento = useRef(false)

  const mostrarBotaoIgualarParcelasAPrazo = () => {
    const existemParcelas = () => (props.parcelas ?? []).length > 0
    const algumaParcelaEhAPrazo = () => (props.parcelas ?? []).some(p => p.DescricaoTipo == "A Prazo")

    return existemParcelas() && algumaParcelaEhAPrazo()
  }

  const valorParametroPorFilial = (nome: string) => props.parametrosPorFilial.find(p => p.Nome == nome)?.Valor // 414608


  const obterValorTotalParcelas = () => R.sum((props.parcelas ?? []).map(p => Math.round(p.Valor * 100) / 100))

  const obterDiferencaValorParcelas = () => (props.orcamento?.ValorTotal ?? 0) - obterValorTotalParcelas()

  const mostrarRodape = () => obterValorTotalParcelas() - obterDiferencaValorParcelas() !== 0 && (!(props.orcamento?.RecalcularParcelas ?? false) || (props.orcamento?.PedidoImportadoECommerce ?? true))

  const toggleParcelaSelecionada = (codigoParcela: number) => {
    if (!isMounted.current) return;

    setCodigosParcelasSelecionadas(codigosParcelasSelecionadas =>
      R.includes(codigoParcela, codigosParcelasSelecionadas) ? codigosParcelasSelecionadas.filter(c => c != codigoParcela) :
        R.append(codigoParcela, codigosParcelasSelecionadas)
    )
  }

  const onSelecionarTodos = (selecionar: boolean) => {
    if (!isMounted.current) return;

    selecionar ? setCodigosParcelasSelecionadas((props.parcelas ?? []).map(parcela => parcela.Codigo)) : setCodigosParcelasSelecionadas([])
  }

  const exibirTipoDocumento = (tipoDocumento: TipoDocumento): boolean => {
    const CodigoFormaPagamento = props.orcamento?.CodigoFormaPagamento ?? ""
    const formaPagamentoSelecionada = props.formasDePagamento.find(f => f.Codigo == CodigoFormaPagamento)

    const tipoParcelaResolvido = formaPagamentoSelecionada?.QuantidadeParcelasPrazo > 0 ? 2 : null

    const validacaoTipoDocumento = () => {
      if (tipoParcelaResolvido == 2) {
        return tipoDocumento.TipoParcela == 2
        }
      if (tipoDocumento.TipoParcela != 2 && tipoDocumento.Tipo == 17763) {
          return tipoDocumento.QuantidadeMaximaParcelaVista >= 1
        }
        if (R.includes(tipoDocumento.TipoParcela, [0, 1]) && tipoDocumento.Tipo != 17763) {
          return true;
        }
        return false;

    }

    return validacaoTipoDocumento()

  }

  useEffect(() => {

    // Atualizar o estado apenas se o componente estiver montado
    if (isMounted.current) {
      setCodigosParcelasSelecionadas([])
    }
  }, [props.parcelas])

  // Cleanup effect para marcar o componente como desmontado
  useEffect(() => {

    return () => {
      isMounted.current = false
    }
  }, [])

  // autoFocus nativo não funciona aqui: no primeiro mount o select ainda está
  // disabled (props.processando=true), então o navegador ignora o foco.
  // Foca manualmente assim que o campo é habilitado pela primeira vez.
  useEffect(() => {
    if (!props.processando && !somenteLeitura && !jaFocouFormaPagamento.current && selectFormaPagamentoRef.current) {
      selectFormaPagamentoRef.current.focus()
      jaFocouFormaPagamento.current = true
    }
  }, [props.processando, somenteLeitura])

  const menuAcoes = <ul className={estilosDropdown.dropdown} >
    <li className={clsx(estilosDropdown.parentL1)}
      id="AbaFormaDePagamento__menu-acoes"
    >
      <span>
        <button
          disabled={props.processando || props.processando || codigosParcelasSelecionadas?.length == 0}
          className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
          id="AbaFormaDePagamento__menu-acoes-botao"
          onClick={() => {
            if (isMounted.current) {
              setExibirMenuAcoes(true)
            }
          }}>
          <FontAwesomeIcon icon={faClipboard} />
          Ações
        </button>
      </span>

      {exibirMenuAcoes && <ul className={clsx(estilosDropdown.childL1, "_border-2 _border-white")} onMouseLeave={() => {
        if (isMounted.current) {
          setExibirMenuAcoes(false)
        }
      }}
        id="AbaFormaDePagamento__menu-acoes-lista"
      >
        <li className="_mb-4 _mt-4"
          onClick={() => props.onMarcarDesmarcarTodosReceberNaEntrega(codigosParcelasSelecionadas)}
          id="AbaFormaDePagamento__menu-acoes-marcar-desmarcar-receber-na-entrega"
        ><span>Marcar Receber Na Entrega</span></li>
      </ul>
      }
    </li>
  </ul>

  const botaoIncluir = <>{!somenteLeitura &&
  <button
    id="AbaFormaDePagamento_incluir"
    className={clsx(estilosBotoes.botaoIcone, estilosBotoes.botaoIconeVerde, 'no-global-button')}
    onClick={(e) => {
      props.onIncluirParcela();
    }}>
    <FontAwesomeIcon
      icon={faCirclePlus}
    />
    Incluir
  </button>
    }</>

  const botaoExcluir = <>{!somenteLeitura && <button
    className={clsx(estilosBotoes.botaoIcone, estilosBotoes.botaoIconeVermelho, 'no-global-button')}
    id="AbaFormaDePagamento_excluir"
    disabled={props.processando || codigosParcelasSelecionadas.length === 0}
    onClick={() => props.onExcluirParcelas(codigosParcelasSelecionadas)}
  >
    <FontAwesomeIcon

      icon={faTimesCircle}
    />
    Excluir
  </button>
    }</>

  const checkboxSelecionarTodos = <div className="_flex _flex-row _items-center">
    <input
      id="abaFormaDePagar__checkbox-selecionar-todos"
      type='checkbox'
      title='Seleciona/deseleciona todos os itens do orçamento - Tecla de atalho [0]'
      accessKey="0"
      //checked={codigosParcelasSelecionadas.length == props.parcelas?.length && props.parcelas?.length > 0}
      ref={input => {
        if (input && isMounted.current) {
          input.checked = codigosParcelasSelecionadas.length == props.parcelas?.length && props.parcelas?.length > 0
          input.indeterminate = codigosParcelasSelecionadas.length > 0 && codigosParcelasSelecionadas.length != props.parcelas?.length;
        }
      }}
      onChange={(e) => onSelecionarTodos(e.target.checked)}
    />
  </div>

  const botaoIgualarParcelasAPrazo = <>{!somenteLeitura && <button
    className={clsx(estilosBotoes.botaoPrimario, 'no-global-button')}
    id="AbaFormaDePagamento_igualarParcelasAPrazo"
    style={{ maxHeight: "30px", alignSelf: "center" }}
    onClick={() => props.onIgualarParcelasPrazo()}
  >
    Igualar Parcelas a Prazo
  </button>
    }</>

  const selectFormaPagamento = <>
    <label
      className={props.existePendenciaPrazoMedioEntrega ? estilosInputs.labelComErro : ''}
      title="Veja parâmetros: &#013;-Exibir somente formas de pagamento da área de vendas?&#013;-Dividir parcelas igualmente apenas em divisão exata&#013;-Dividir parcelas igualmente" // 480391
		id="AbaFormaDePagamento_Label_FormaDePagamento"
    >Forma de Pagamento</label>
    <select
      className={props.existePendenciaPrazoMedioEntrega ? estilosInputs.inputComErro : ''}
      name="formaDePagamento"
      id="AbaFormaDePagamento_FormaDePagamento"
      ref={selectFormaPagamentoRef}
      value={props.orcamento?.CodigoFormaPagamento ?? ""}
      disabled={props.processando || somenteLeitura}
      onChange={(e) => {

        props.onFormaDePagamentoModificada(Number(e.target.value))
        // setExibirGrid(true);
        // setRecalcularParcelas(false);
        // setTipoDeDocumentoSelecionado(props.tiposDeDocumento[0]);
        // setParcelasSelecionadas([]);
      }}
    >
      <option value="" id={`AbaFormaDePagamento_FormaDePagamento_Opcao_Selecione`}>Selecione</option>

      {props.formasDePagamento.map((f, index) => (
        <option
          key={index}
          id={`AbaFormaDePagamento_FormaDePagamento_Opcao_${f.Codigo}`}
          value={f.Codigo}
        >
          {f.Nome}
        </option>
      ))}
    </select>
  </>

  const selectTipoDocumento = <>
    <label>Tipo de Documento</label>
    <select
      className={estiloAbaFormaDePagamento.select}
      name="tipoDeDocumento"
      id="AbaFormaDePagamento_TipoDeDocumento"
      value={props.orcamento?.CodigoTipoDocumento ?? ""}
      disabled={props.processando || somenteLeitura  || props.orcamento?.CodigoFormaPagamento <= 7 || props.tiposDeDocumento?.length <= 1}
      onChange={(e) => {

        props.onTipoDeDocumentoModificado(Number(e.target.value))

        if (isMounted.current) {
          setCodigosParcelasSelecionadas([]);
        }
      }}
    >
      <option value="" id={`AbaFormaDePagamento_tipoDeDocumento_Opcao_Selecione`}>Selecione</option>
      {(props.tiposDeDocumento ?? []).filter(exibirTipoDocumento).map((value) => (
        <option key={value.Codigo} value={value.Codigo}
          id={`AbaFormaDePagamento_tipoDeDocumento_Opcao_${value.Codigo}`}
        >
          {value.Descricao}
        </option>
      ))}
    </select>
  </>

  const recalcularParcelasComponent = <>
    <label htmlFor="formaPagamento_RecalcularParcelas" style={{ cursor: 'pointer' }}>Recalcular Parcelas</label>
    <div className="_flex _flex-row _gap-4">

      <input
        className={estiloAbaFormaDePagamento.checkbox}
        type="checkbox"
        id="formaPagamento_RecalcularParcelas"
        checked={(props.orcamento?.RecalcularParcelas && !props?.orcamento?.PedidoImportadoECommerce) ?? false}
        onChange={() => props.onRecalcularParcelasModificado(!(props.orcamento?.RecalcularParcelas ?? false))}
        disabled={props.processando || somenteLeitura}
      />

      <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}>
        <FontAwesomeIcon
          className={estiloAbaFormaDePagamento.icone_info}
          icon={faCircleInfo}
          onClick={() => props.onMostrarAjudaRecalcularParcelas()}
        />
      </button>

    </div>
  </>

  const recalcularPrecosComponent = <>
    <label title="Recalculará o preço ao mudar a forma de pagamento - Veja parâmetro: Recalcular os valores do pedido automaticamente quando a condição de pagamento for alterada"
      htmlFor="formaPagamento_RecalcularPrecos" style={{ cursor: 'pointer' }}>
      Recalcular Preços</label>
    <div className="_flex _flex-row _gap-4">

      <input
        className={estiloAbaFormaDePagamento.checkbox}
        id="formaPagamento_RecalcularPrecos"
        type="checkbox"
        title="Recalculará o preço ao mudar a forma de pagamento - Veja parâmetro: Recalcular os valores do pedido automaticamente quando a condição de pagamento for alterada"
        checked={(props.orcamento?.RecalcularPrecos && !props.orcamento?.PedidoImportadoECommerce) ?? false}
        disabled={props.processando || somenteLeitura}
        onChange={() => props.onRecalcularPrecosModificado(!(props.orcamento?.RecalcularPrecos ?? false))}
      />

      <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
        id="AbaFormaDePagamento_botao_info_recalcularPrecos"
      >
        <FontAwesomeIcon
          id="AbaFormaDePagamento_icone_info_recalcularPrecos"
          className={estiloAbaFormaDePagamento.icone_info}
          icon={faCircleInfo}
          onClick={() => props.onMostrarAjudaRecalcularPrecos()}
        />
      </button>

    </div>
  </>

  const rodape = <>
    <>
      <tr
        id="AbaFormaDePagamento_Grid_Rodape_Soma"
      >
        <th colSpan={2} className={estilosTabelas.cabecalhoNumerico}
          id="AbaFormaDePagamento_Grid_Rodape_Soma_Coluna1"
        >
          Soma
        </th>
        <th className={estilosTabelas.dadoNumerico}
          id="AbaFormaDePagamento_Grid_Rodape_Soma_Coluna2"
        >
          {globalMU.formatarValorNumerico(obterValorTotalParcelas(), 2, true)}
        </th>
        <th colSpan={6}
          id="AbaFormaDePagamento_Grid_Rodape_Soma_Coluna3"
        >

        </th>
      </tr>

      <tr
        id="AbaFormaDePagamento_Grid_Rodape_Diferenca"
      >
        <th colSpan={2} className={estilosTabelas.cabecalhoNumerico}
          id="AbaFormaDePagamento_Grid_Rodape_Diferenca_Coluna1"
        >
          Diferença
        </th>
        <th className={estilosTabelas.dadoNumerico}
          id="AbaFormaDePagamento_Grid_Rodape_Diferenca_Coluna2"
        >
          {globalMU.formatarValorNumerico(obterDiferencaValorParcelas(), 2, true)}
        </th>
        <th colSpan={6}
          id="AbaFormaDePagamento_Grid_Rodape_Diferenca_Coluna3"
        >

        </th>
      </tr>
    </>
  </>

  const gridParcelas = <>
    <div className={estiloTabela.containerRolavel}>
    <table className={`_table _w-full _border-collapse text-right ${estiloTabela.tabela}`}
      id="AbaFormaDePagamento__tabela-parcelas"
    >
      <thead
        id="AbaFormaDePagamento__tabela-parcelas-cabecalho"
      >
        <tr
          id="AbaFormaDePagamento__tabela-parcelas-cabecalho-linha"
        >
          <th className={estilosTabelas.cabecalhoTexto}
            id="AbaFormaDePagamento__tabela-parcelas-cabecalho-tipo"
          >Tipo</th>
          <th className={estilosTabelas.cabecalhoTexto}
            id="AbaFormaDePagamento__tabela-parcelas-cabecalho-documento"
          >Documento</th>
          <th className={estilosTabelas.cabecalhoNumerico}
            id="AbaFormaDePagamento__tabela-parcelas-cabecalho-valor"
          >Valor</th>
          <th className={estilosTabelas.cabecalhoTexto}
            id="AbaFormaDePagamento__tabela-parcelas-cabecalho-vencimento"
          >Vencimento</th>
          <th className={estilosTabelas.cabecalhoNumerico}
            id="AbaFormaDePagamento__tabela-parcelas-cabecalho-quantidade-parcelas"
          >Quantidade <br />de Parcelas</th>
          <th className={estilosTabelas.cabecalhoNumerico}
            id="AbaFormaDePagamento__tabela-parcelas-cabecalho-valor-parcelas"
          >Valor das<br /> Parcelas {props.possuiCartaoParcelado ? '*' : ''} </th>
            {props.exibirColunaReceberNaEntrega &&
              <th className={estilosTabelas.cabecalhoOperacao}
                id="AbaFormaDePagamento__tabela-parcelas-cabecalho-receber-na-entrega"
                >Receber<br /> na Entrega</th>}
          <th></th>
        </tr>
      </thead>
      <tbody
        id="AbaFormaDePagamento__tabela-parcelas-corpo"
      >
        {(props.parcelas ?? []).map((parcela, index) =>
          <tr
            key={index}
            id={`AbaFormaDePagamento_Grid_Index_${index}`}
            className={clsx(
              estilosTabelas.linhaClicavel,
              R.includes(parcela.Codigo, codigosParcelasSelecionadas) ? estilosTabelas.linhaSelecionada : '')}

            onClick={(() => toggleParcelaSelecionada(parcela.Codigo))}
            >

            <td className={clsx(estilosTabelas.dadoTexto, estilosTabelas.textoNaoQuebravel)}
                style={{ boxShadow: parcela.DocumentoElegivelPIXaPrazo ? '4px 0 var(--mu-azul-marcador, #00f) inset' : undefined }}
                id={`AbaFormaDePagamento_Grid_Index_${index}_Coluna_Tipo`}
            >
              {parcela.DescricaoTipo}
            </td>

            <td className={clsx(estilosTabelas.dadoTexto, estilosTabelas.textoNaoQuebravel)}
              id={`AbaFormaDePagamento_Grid_Index_${index}_Coluna_Documento`}
            >
              {parcela.Documento}
            </td>
            <td className={estilosTabelas.dadoNumerico}
              id={`AbaFormaDePagamento_Grid_Index_${index}_Coluna_Valor`}
            >
              {globalMU.formatarValorNumerico(parcela.Valor, 2, true)}
            </td>
            <td className={estilosTabelas.dadoTexto}
              id={`AbaFormaDePagamento_Grid_Index_${index}_Coluna_Vencimento`}
            >
              {globalMU.formatDate(new Date(parcela.Vencimento))}
            </td>
            <td className={estilosTabelas.dadoNumerico}
              id={`AbaFormaDePagamento_Grid_Index_${index}_Coluna_QuantidadeParcelas`}
            >
              {parcela.QuantidadeParcelasCartao}
            </td>
            <td className={estilosTabelas.dadoNumerico}
                id={`AbaFormaDePagamento__tabela-parcelas-linha-${index}-coluna-valor-parcelas`}
            >
              {globalMU.formatarValorNumerico(parcela.ValorParcelasCartao, 2, true)}
            </td>
            {props.exibirColunaReceberNaEntrega &&
              <td className={estilosTabelas.dadoOperacao}
                id={`AbaFormaDePagamento_Grid_Index_${index}_Coluna_ReceberNaEntrega`}
              >
                <input type="checkbox"
                        id={`AbaFormaDePagamento_Grid_Index_${index}_Checkbox_ReceberNaEntrega`}
                        disabled={props.processando || somenteLeitura}
                       onChange={(e) => props.onReceberNaEntrega({
                         ...parcela,
                         RecebimentoNaEntrega: e.target.checked
                       })}
                    checked={parcela.RecebimentoNaEntrega ?? false} />
              </td>}
            <td
              id={`AbaFormaDePagamento_Grid_Index_${index}_Coluna_Editar`}
            >
              <button className={clsx(estilosBotoes.botaoIcone, 'no-global-button')}
                  id={`AbaFormaDePagamento__tabela-parcelas-linha-${index}-coluna-editar-parcela`}
              >
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  id={`AbaFormaDePagamento__icone-editar-parcela-${index}`}
                  onClick={(e) => {
                    props.onEditarParcela(parcela.Codigo);
                    e.stopPropagation();
                  }} />
              </button>
            </td>

          </tr>)}

        {mostrarRodape() && rodape}
      </tbody>
    </table>
    </div>

    {props.possuiCartaoParcelado && <span>(*) O valor correto das parcelas deve ser verificado com a administradora de cartão</span>}

    {valorParametroPorFilial("TRABALHA_COBRANCA_PIX_PRAZO") == "S" && // 414608
      <Legenda
        itens={[
          {
              nome: "Elegível para Cobrança PIX a Prazo", // 414608
            cor: "var(--mu-azul-marcador, #00f)",
              title: "Veja parâmetro: PIX a Prazo: Trabalha com recebimento PIX a Prazo" // 414608

          },
      ]} />
    }
  </>


  return (
    <>
      <div className={estiloAbaFormaDePagamento.separador}
        id="AbaFormaDePagamento__separador"
      >
      </div>

      <div className={estilosFormulario.formulario}
        id="AbaFormaDePagamento__container-formulario"
      >
        {selectFormaPagamento}

        {selectTipoDocumento}

        {recalcularParcelasComponent}

        {recalcularPrecosComponent}

      </div>

      <>{!somenteLeitura &&
      <div className="_flex _flex-row _gap-4 _mb-4"
        id="AbaFormaDePagamento__botoes-acoes"
      >
        {botaoIncluir}

        {botaoExcluir}

        {props.exibirColunaReceberNaEntrega && menuAcoes}

        {mostrarBotaoIgualarParcelasAPrazo() && botaoIgualarParcelasAPrazo}
      </div>
      }</>


      <>{!somenteLeitura &&
        <div
          className="_flex _flex-row _gap-x-1 _mt-4"
        style={{ alignItems: 'baseline', cursor: 'default' }}
        id="AbaFormaDePagamento__info-parcelas-selecionadas"
      >
        {checkboxSelecionarTodos}

        {`Selecionado(s) ${codigosParcelasSelecionadas.length} de ${props.parcelas?.length} `}
      </div>
      }</>

      {gridParcelas}
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};

export { AbaFormaDePagamento };